import * as React from 'react';
import {Component, I18NString } from "../Utils";
import { isUndefined } from 'lodash';

interface Props {
    id: string;
    required: boolean;
    contentNumb: string;
    title: I18NString;
    status?: string;
    disabled?: boolean;
    disableNumber?: boolean;
}

class Field extends Component<Props,{}>{
    defaultProps :{
        status: "default"
    }

    getStateGroup() : string {
        let className = "form-group";
        if(isUndefined(this.props.disabled) && !this.props.disabled){
            switch(this.props.status){
                case "error":  className += " has-error";
                    break;
                case "success": className += " has-success";
                    break
                default: className = "form-group";
                    break;
            } 
           
            return className;
        }

        return className

    }

    render(){
        const { id,  required, title, contentNumb, disableNumber } = this.props;
        
        return(
            <div id={id} className={this.getStateGroup()}>
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-5">
                    <label className="control-label">
                        <div className="reportbox-content-num">{(disableNumber) ? '' : contentNumb }</div>
                        <div
                            className={required ? "reportbox-content-desc required" : "reportbox-content-desc"}
                            dangerouslySetInnerHTML={{__html: this.tr(title)}}
                        />
                    </label>
                </div>
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-7">
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default Field;


// WEBPACK FOOTER //
// ./src/components/controls/Field.tsx